import { Component, OnInit } from '@angular/core';
declare const BMap: any;

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss', './contact.component.media.scss']
})
export class ContactComponent implements OnInit {
  title: boolean;
  constructor() { }

  ngOnInit() {
    const map = new BMap.Map("map-div", {minZoom:13,maxZoom:18});
    // 创建地图实例
    const point = new BMap.Point(121.791183,29.913701);
    const p = new BMap.Point(121.791179,29.913606);
    const marker = new BMap.Marker(p);        // 创建标注
    map.addOverlay(marker);                     // 将标注添加到地图中
    // 创建点坐标
    map.centerAndZoom(point, 18);
    // 初始化地图，设置中心点坐标和地图级别
    map.enableScrollWheelZoom(true);
    // map.disableDragging();

    const opts = {
      width : 250,     // 信息窗口宽度
      height: 60,     // 信息窗口高度
    }
    const infoWindow = new BMap.InfoWindow("<div style='font-size: 14px'>宁波华日金属制品有限公司 <br/> 浙江省宁波市北仑大矸工业区沿山河路129号</div>", opts);  // 创建信息窗口对象
    map.openInfoWindow(infoWindow, map.getCenter());
  }

}
